import { TCategoriesRevenue } from '../../api/APITypes';

export const MOCK_CATEGORIES_REVENUES: TCategoriesRevenue = [
  {
    category_name: 'Baking',
    total_revenue: 970593.07,
    total_margin: 135911.18000000005,
  },
  {
    category_name: 'Soft drinks',
    total_revenue: 711750.6100000007,
    total_margin: 92005.37000000002,
  },
  {
    category_name: 'Fish',
    total_revenue: 642263.2699999999,
    total_margin: 62609.19999999998,
  },
  {
    category_name: 'Tobacco',
    total_revenue: 494086.2400000002,
    total_margin: 87124.67999999993,
  },
  {
    category_name: 'Vegetables',
    total_revenue: 474223.2199999998,
    total_margin: 41830.26999999998,
  },
  {
    category_name: 'Meat',
    total_revenue: 399037.34000000026,
    total_margin: 68428.08000000002,
  },
  {
    category_name: 'Cheese',
    total_revenue: 363114.4799999999,
    total_margin: 27075.65,
  },
  {
    category_name: 'Alcohol',
    total_revenue: 350288.24000000017,
    total_margin: 71262.40000000004,
  },
  {
    category_name: 'Snacks',
    total_revenue: 248270.30999999988,
    total_margin: 24677.39,
  },
];
